import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { moods } from "@/mocks/moods";

export default function MoodSection() {
  const [active, setActive] = useState(moods[0].id);
  const current = moods.find((m) => m.id === active) ?? moods[0];

  return (
    <section id="mood" className="py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">By Mood</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">按心情选片：先说自己想要什么</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              同一类电影也有不同看法。先想清楚此刻想要的是思考、是陪伴，还是单纯放松，再挑一部会顺利很多。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <Reveal className="lg:col-span-5">
            <ul className="space-y-3">
              {moods.map((m) => {
                const isActive = m.id === active;
                return (
                  <li key={m.id}>
                    <button
                      type="button"
                      onClick={() => setActive(m.id)}
                      aria-pressed={isActive}
                      className={`w-full text-left rounded-lg border p-4 flex items-start gap-4 transition-colors cursor-pointer ${
                        isActive
                          ? "bg-primary-500 border-primary-500"
                          : "bg-background-50 border-background-200 hover:border-primary-300"
                      }`}
                    >
                      <span
                        className={`w-10 h-10 rounded-md flex items-center justify-center shrink-0 ${
                          isActive ? "bg-background-50/20 text-background-50" : "bg-primary-100 text-primary-600"
                        }`}
                      >
                        <i className={`${m.icon} text-xl`}></i>
                      </span>
                      <span className="flex-1">
                        <span
                          className={`block font-heading text-base font-semibold ${
                            isActive ? "text-background-50" : "text-foreground-950"
                          }`}
                        >
                          {m.title}
                        </span>
                        <span
                          className={`block mt-1 text-xs leading-relaxed ${
                            isActive ? "text-background-100/90" : "text-foreground-500"
                          }`}
                        >
                          {m.desc}
                        </span>
                      </span>
                      <i
                        className={`mt-1 transition-transform ${
                          isActive ? "ri-arrow-right-line text-background-50" : "ri-add-line text-foreground-400"
                        }`}
                      ></i>
                    </button>
                  </li>
                );
              })}
            </ul>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={100}>
            <div className="h-full rounded-lg border border-background-200 bg-background-50 p-6 md:p-8 flex flex-col">
              <div className="flex items-center gap-2 text-secondary-700">
                <i className="ri-compasses-2-line text-xl"></i>
                <span className="text-xs font-label tracking-widest uppercase">本期推荐</span>
              </div>
              <h3 className="mt-3 font-heading text-xl md:text-2xl font-bold text-foreground-950">{current.title}</h3>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">{current.desc}</p>

              <div className="mt-6 pt-6 border-t border-background-200">
                <p className="text-xs font-label tracking-widest text-foreground-500 uppercase">可以先看这几部</p>
                <ul className="mt-4 space-y-3">
                  {current.picks.map((p, i) => (
                    <li
                      key={p}
                      className="flex items-center gap-4 rounded-md bg-background-100 border border-background-200 px-4 py-3"
                    >
                      <span className="font-heading text-lg text-accent-600 font-semibold w-6">{String(i + 1).padStart(2, "0")}</span>
                      <span className="text-sm md:text-base text-foreground-900 font-medium flex-1">{p}</span>
                      <i className="ri-film-line text-foreground-400"></i>
                    </li>
                  ))}
                </ul>
              </div>

              <a
                href="#collection"
                className="mt-6 inline-flex items-center justify-center gap-2 self-start px-5 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm font-label hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                去片单里查看全部
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}